import { GridColumnMenu, GridColumnMenuProps } from "@mui/x-data-grid-pro";

import TimeGroupingMenuItem from "./TimeGroupingMenuItem";
import { ChartTimeGrouping } from "./types";

interface SmartGroupsTableColumnMenuProps extends GridColumnMenuProps {
  chartKey?: string;
  chartLabel?: string;
  chartTimeGrouping?: ChartTimeGrouping;
  onChartTimeGroupingChange?: (value: ChartTimeGrouping) => void;
}

const SmartGroupsTableColumnMenu = ({
  chartKey,
  chartLabel,
  chartTimeGrouping,
  onChartTimeGroupingChange,
  ...props
}: SmartGroupsTableColumnMenuProps) => {
  const isChartColumn = props.colDef.field === chartKey;

  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuColumnsItem: null,
        ...(isChartColumn && {
          columnMenuTimeGroupingItem: TimeGroupingMenuItem,
        }),
      }}
      slotProps={{
        ...(isChartColumn && {
          columnMenuTimeGroupingItem: {
            displayOrder: 5,
            chartLabel,
            chartTimeGrouping,
            onChartTimeGroupingChange,
            hideMenu: props.hideMenu,
          },
        }),
      }}
    />
  );
};

export default SmartGroupsTableColumnMenu;
